var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){_vm.preview = !_vm.preview}}},[_c('img',{class:[_vm.$style.img,_vm.$style[_vm.className]],attrs:{"src":_vm.src}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preview),expression:"preview"}],class:_vm.$style.bg},[_c('img',{attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }